import http from "../utils/http";

//汇总信息

export function getEwSummary(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/ewSummary',
        params: params
    });
}


//食品预警
export function getEwFoodExpired(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/foodExpired/paging',
        params: params
    });
}

//监督检查预警
export function getSupervise(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/patrol/paging',
        params: params
    });
}

//后厨管理预警
export function getEwChefList(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/chef/paging',
        params: params
    });
}

//AI预警
export function getAiWarn(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/aiCamera/paging',
        params: params
    });
}
//健康证预警
  
export function getEwHealthList(params) {
    return http({
        method: 'POST',
        url: '/ew/entity/health/paging',
        data: params
    });
}
//许可证预警
  
export function getEwLicenceList(params) {
    return http({
        method: 'POST',
        url: '/ew/entity/licence/paging',
        data: params
    });
}

//溯源异常
export function getEwOriginExpired(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/origin/paging',
        params: params
    });
}
//检测异常
export function getEwDetectExpired(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/detect/paging',
        params: params
    });
}
//投诉反馈
export function getEwComplainExpired(params) {
    return http({
        method: 'POST',
        url: '/ew/entity/complain/paging',
        data: params
    });
}
//各类详情处理
export function handleDetail(params, url) {
    return http({
        method: 'POST',
        url: url,
        data: params
    });
}

//AI预警小类型汇总
export function getSmallTypeList(params) {
  return http({
      method: 'GET',
      url: '/ew/entity/aiCamera/small/type/paging',
      params: params
  });
}
//AI预警小类型汇总--高新定制
export function getEntityNewPaging(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/new/paging',
        params: params
    });
}
//AI摄像头预警-详情列表--高新定制
export function getEntityDetailPaging(params) {
    return http({
        method: 'GET',
        url: '/ew/entity/detail/paging',
        params: params
    });
}
//预警考核统计
export function getAssessStatistics(params) {
  return http({
      method: 'POST',
      url: '/ew/entity/statistics',
      data: params
  });
}